(function () {
  function fetchAndInject(section) {
    var url = section.dataset.recommendationsUrl;
    if (!url) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var fetchedGrid = tmp.querySelector('.oddit-section-recommended-products__grid');

        if (!fetchedGrid || !fetchedGrid.querySelector('.oddit-section-recommended-products__card')) {
          section.hidden = true;
          return;
        }

        var currentGrid = section.querySelector('.oddit-section-recommended-products__grid');
        if (currentGrid) {
          currentGrid.innerHTML = fetchedGrid.innerHTML;
        }

        bindCarousel(section);
      })
      .catch(function () {
        section.hidden = true;
      });
  }

  function bindCarousel(section) {
    var grid = section.querySelector('.oddit-section-recommended-products__grid');
    var prevBtn = section.querySelector('.oddit-section-recommended-products__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-recommended-products__arrow--next');

    if (!grid || !prevBtn || !nextBtn) return;

    if (typeof section._odditRecommendedCleanup === 'function') {
      section._odditRecommendedCleanup();
    }

    var CARD_WIDTH = 320;
    var GAP = 20;
    var SCROLL_AMOUNT = CARD_WIDTH + GAP;

    function onPrevClick() {
      grid.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
    }

    function onNextClick() {
      grid.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', onPrevClick);
    nextBtn.addEventListener('click', onNextClick);

    section._odditRecommendedCleanup = function () {
      prevBtn.removeEventListener('click', onPrevClick);
      nextBtn.removeEventListener('click', onNextClick);
    };
  }

  function initRecommendedProducts(container) {
    var section = container || document.querySelector('.oddit-section-recommended-products');
    if (!section) return;

    var url = section.dataset.recommendationsUrl;
    if (!url) return;

    if (section._odditObserver) {
      section._odditObserver.disconnect();
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        fetchAndInject(section);
      },
      { rootMargin: '0px 0px 600px 0px' }
    );

    observer.observe(section);
    section._odditObserver = observer;
  }

  // Initial load
  initRecommendedProducts();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.oddit-section-recommended-products');
    if (section) initRecommendedProducts(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.oddit-section-recommended-products');
    if (!section) return;
    if (section._odditObserver) section._odditObserver.disconnect();
    if (typeof section._odditRecommendedCleanup === 'function') section._odditRecommendedCleanup();
  });
})();
